import React from 'react';

const Loader = ({
  width = '40px',
  height = '40px'
}) => (
  <div className="spinner" style={{width, height}}>
    <div className="double-bounce1" />
    <div className="double-bounce2" />
</div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/agent/Components/Loader.jsx